import * as React from 'react';
import { EpiserverProperty } from 'sos-common/js/utils/episerver.property';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';

export interface IHeadingProps {}
export interface IHeadingState extends FormSectionBaseState {}

export default class Heading extends FormSectionBase<IHeadingProps, IHeadingState> {
  constructor(props: IHeadingProps) {
    super(props);

    this.state = {
      errors: this.emptyErrorsMap,
    };
  }

  public render() {
    const { isInEditMode } = this.context;
    return (
      <>
        <EpiserverProperty propertyName="Heading" isInEditMode={isInEditMode}>
          <h1>{this.findProperty('Heading')}</h1>
        </EpiserverProperty>
        <EpiserverProperty propertyName="SubHeading" isInEditMode={isInEditMode} wrappingElement="span">
          <p>{this.findProperty('SubHeading')}</p>
        </EpiserverProperty>
      </>
    );
  }
}
